import { render, staticRenderFns } from "./reformList.vue?vue&type=template&id=65559452"
import script from "./reformList.vue?vue&type=script&lang=js"
export * from "./reformList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports